import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  checkbox: {
    width: "25px",
    height: "25px",
  },
  title: {
    textAlign: "center",
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const EditCarrier = () => {
  const { carrierId } = useParams();
  const classes = useStyles();

  const [carrierObj, setCarrierObj] = useState({
    carrier: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Carriers/" + carrierId)
      .then((response) => response.json())
      .then((data) =>
        setCarrierObj({
          carrier: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {carrierObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <EditForm carrier={carrierObj.carrier} />
      )}
    </>
  );
};

const EditForm = ({ carrier: carrier }) => {
  const classes = useStyles();
  const history = useNavigate();

  const name = carrier.name;
  const contactName = carrier.contactName;
  const contactEmail = carrier.contactEmail;
  const contactPhone = carrier.contactPhone;

  const [carrierData, setCarrierData] = useState({
    name: name,
    contactName: contactName,
    contactEmail: contactEmail,
    contactPhone: contactPhone,
  });

  const [submitData, setSubmitData] = useState(carrierData);
  const [loading, setLoading] = useState(false);

  const myChangeHandler = (value, name) => {
    if (value === "") value = null;
    setSubmitData({
      ...submitData,
      [name]: value,
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (
      submitData.name === carrierData.name &&
      submitData.contactName === carrierData.contactName &&
      submitData.contactEmail === carrierData.contactEmail &&
      submitData.contactPhone === carrierData.contactPhone
    ) {
      sendAlert(`No Changes Made`, "warning");
      return;
    }

    setCarrierData((prev) => ({
      ...prev,
      name: submitData.name,
      contactName: submitData.contactName,
      contactEmail: submitData.contactEmail,
      contactPhone: submitData.contactPhone,
    }));

    setLoading(true);
    var success = false;

    fetchWithToken(`api/Carriers/${carrier.id}`, "PUT", submitData)
      .then((res) => {
        if (res.ok) success = true;
        return res.json();
      })
      .then((data) => {
        sendAlert(data.returnMessage, success ? "success" : "error");
        setLoading(false);
        if (success) setCarrierData({ ...submitData });
      });
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <CardContent>
              <Typography
                sx={{ fontSize: 14 }}
                style={{ margin: "20px", fontSize: "1.5em" }}
                color="text.secondary"
                gutterBottom
                variant="h6"
                id="tableTitle"
                component="div"
              >
                Edit Carrier: {carrier.id}
              </Typography>

              <div class="mb-3 row" style={{ margin: "5px" }}>
                <label for="name" class="col-sm-4 col-form-label">
                  <h6>Name:</h6>
                </label>
                <div class="col-sm-8">
                  <input
                    name="name"
                    type="text"
                    maxLength="30"
                    class="form-control form-control-sm"
                    defaultValue={carrier.name}
                    onChange={(e) => {
                      clearAlert();
                      myChangeHandler(e.target.value, "name");
                    }}
                  />
                </div>
              </div>

              <div class="mb-3 row" style={{ margin: "5px" }}>
                <label for="contactName" class="col-sm-4 col-form-label">
                  <h6>Contact Name:</h6>
                </label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    name="contactName"
                    class="form-control form-control-sm"
                    maxLength="30"
                    defaultValue={carrier.contactName}
                    onChange={(e) => {
                      clearAlert();
                      myChangeHandler(e.target.value, "contactName");
                    }}
                  />
                </div>
              </div>

              <div class="mb-3 row" style={{ margin: "5px" }}>
                <label for="contactEmail" class="col-sm-4 col-form-label">
                  <h6>Contact Email:</h6>
                </label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    name="contactEmail"
                    class="form-control form-control-sm"
                    maxLength="50"
                    defaultValue={carrier.contactEmail}
                    onChange={(e) => {
                      clearAlert();
                      myChangeHandler(e.target.value, "contactEmail");
                    }}
                  />
                </div>
              </div>

              <div class="mb-3 row" style={{ margin: "5px" }}>
                <label for="contactPhone" class="col-sm-4 col-form-label">
                  <h6>Contact Phone:</h6>
                </label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    name="contactPhone"
                    class="form-control form-control-sm"
                    maxLength="30"
                    defaultValue={carrier.contactPhone}
                    onChange={(e) => {
                      clearAlert();
                      myChangeHandler(e.target.value, "contactPhone");
                    }}
                  />
                </div>
              </div>

              {loading && (
                <>
                  <div style={{ margin: "25px" }}>
                    <span style={{ display: "table", margin: "0 auto" }}>
                      Please Wait For Carrier Update to Finish
                    </span>
                    <LinearProgress />
                  </div>
                </>
              )}
              <Button
                variant="contained"
                className={classes.button}
                onClick={submitHandler}
                color="primary"
              >
                Update
              </Button>
              <Button
                variant="contained"
                className={classes.button}
                onClick={() => history("/carrier/manage")}
              >
                Cancel
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default EditCarrier;
